<template>
    <div>
        <div class="link">
            <el-row>
                <el-col :span="8">
                    <h3>{{$t('friendlink')}}</h3>
                    <div class="link-info"><a href="https://www.free-api.com" target="_black">免费API</a></div>
                    <div class="link-info"><a href="http://www.php.cn" target="_black">php中文网</a></div>
                    <div class="link-info"><a href="http://www.html5cn.org" target="_black">html5中国</a></div>
                    <div class="link-info"><a href="http://www.mysqlpub.com" target="_black">Mysql社区</a></div>
                    <div class="link-info"><a href="http://www.w3school.com.cn" target="_black">W3school</a></div>
                </el-col>
                <el-col :span="8">
                    <h3>{{$t('shouce')}}</h3>
                    <div class="link-info"><a href="http://www.php.net/manual/zh/" target="_black">php7手册</a></div>
                    <div class="link-info"><a href="http://doc.mysql.cn/" target="_black">mysql手册</a></div>
                    <div class="link-info"><a href="http://laravelacademy.org/laravel-docs-5_4" target="_black">Laravel手册</a></div>
                    <div class="link-info"><a href="https://www.kancloud.cn/manual/thinkphp5/118003" target="_black">Thinkphp5手册</a></div>
                </el-col>
                <el-col :span="8">
                    <h3>{{$t('grassortree')}}</h3>
                    <div class="link-info">
                        <div class="tile" @mouseenter="msg='当你是一棵小草的时候，凭什么让远方的人们看见你……'" @mouseleave="msg=''">
                            <div class="wrap">

                                <div class="text">
                                    <img v-lazy="'http://img.fang99.cc/tree.png'"/>
                                    <h1>{{msg}}</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>

            </el-row>
        </div>
        <div class="copyright">
          Copyright © 2017-{{year}} <a href="https://beian.miit.gov.cn/" target="_blank">皖ICP备17018155号-1</a>. All rights reserved | Design by FZS
        </div>
    </div>
</template>

<script>

    export default {
        name: "BlogFoot",
        data () {
            return {
                year:getYear(),
                msg:''
            }
        }
    }
    function getYear(){
        var date = new Date();
        var year = date.getFullYear();
        return year;
    }
</script>

<style scoped>
    .copyright{
        height: 180px;
        background-color: #000000;
        color: white;
        text-align: center;
        height: 20px;
        padding: 32px 0px;
        font-size: 13px;
    }
    .link{
        height: 180px;
        background-color: #252525;
        text-align: center;
    }
    .link h3{
        font-size: 14px;
        color: white;
    }
    a{
        font-size: 13.5px;
        color: #817F7F;
        text-decoration:none;
        font-weigh:lighter;
        border-bottom: 1px dotted;
    }
    a:hover{
        color: white;
        text-decoration:none;
        font-weight: normal;
    }
    .wrap { margin: 0 auto; width: 250px;height: 100px; }
    .tile { width: 250px; height: 100px;  display: inline-block; background-size: cover; position: relative; cursor: pointer; transition: all 0.4s ease-out; box-shadow: 0px 35px 77px -17px rgba(0, 0, 0, 0.44); overflow: hidden; color: white; }
    .tile img {  width: 250px; height: 100px; z-index: 0; transition: all 0.4s ease-out; }
    .tile .text { z-index: 99; position: absolute; }
    .tile h1 { font-size:13px;margin-top: -40px;font-weight: 300; text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);}
    .tile:hover {  transform: scale(1.05); }
    .tile:hover img { opacity: 0.2; }
    .tile:hover span { opacity: 1; transform: translateY(0px); }
</style>



// WEBPACK FOOTER //
// src/components/common/BlogFoot.vue